import RainbowTextField from '@components/RainbowTextField/RainbowTextField'
import { Icon } from '@mui/material'
import React, { FC } from 'react'
import { TfiSearch } from 'react-icons/tfi'

interface Props {
  searchTerm: string
  setSearchTerm: (value: string) => void
  placeholder: string
  autoFocus?: boolean
}

const SearchBar: FC<Props> = ({ searchTerm, setSearchTerm, placeholder, autoFocus }) => (
  <RainbowTextField
    startAdornment={
      <Icon>
        <TfiSearch size={15} />
      </Icon>
    }
    value={searchTerm}
    onChange={({ target: { value } }) => setSearchTerm(value)}
    placeholder={placeholder}
    autoFocus={!!autoFocus}
  />
)

export default SearchBar
